import { STORE_ROUTER_HISTORY } from './router.actionTypes';

export const actionCreators = {
	doStoreRouterHistory: (history: Object) => ({
		type: STORE_ROUTER_HISTORY,
		history,
	}),
};

export type RouterActionType = ReturnType<typeof actionCreators.doStoreRouterHistory>;
